import { AsyncPipe } from '@angular/common';
import { Component, inject } from '@angular/core';
import { UsuariosService } from '@modules/usuarios/services/usuarios.service';
import { IconComponent } from '@shared/components/icon/icon.component';
import { LogoEmpresaComponent } from '@shared/components/logo-empresa/logo-empresa.component';
import { AppButtonDirective } from '@shared/ui/button/app-button.directive';
import { shareReplay } from 'rxjs';
import { ModalTenentService } from '../../services/modal-tenent.service';

@Component({
  selector: 'app-tenant-logado-navbar',
  template: `
    <div class="relative flex items-center">
      @if (usuarioLogado$ | async; as usuario) {
        <div class="animate-fade-in flex flex-row gap-3">
          <button
            type="button"
            appButton
            (click)="toggleModal()"
            class="group flex h-10 flex-row items-center gap-2 rounded-lg border border-gray-200 bg-transparent pl-1.5 pr-2.5 text-xs font-medium text-content-secondary transition-colors hover:bg-gray-200/60"
            variant="link"
          >
            <app-logo-empresa
              tamanho="sm"
              daEmpresaAtual
              [nome]="usuario.tenant"
              [logoAnexoId]="usuario.logoAnexoId"
              [logoUrl]="usuario.logoUrl"
            />
            <span class="line-clamp-1 text-xs">{{ usuario.tenant.toUpperCase() }}</span>
            <app-icon class="flex items-center text-content-tertiary" name="arrow_reload_horizontal" />
          </button>
        </div>
      } @else {
        <div class="animate-fade-in flex items-center space-x-2">
          <div class="h-4 w-4 animate-spin rounded-full border-2 border-gray-300 border-t-transparent"></div>
          <span class="text-sm text-gray-500">Carregando...</span>
        </div>
      }
    </div>
  `,
  styles: [],
  imports: [AppButtonDirective, IconComponent, LogoEmpresaComponent, AsyncPipe],
})
export class TenantLogadoNavbarComponent {
  protected readonly usuarioService = inject(UsuariosService);
  protected usuarioLogado$ = this.usuarioService.usuarioLogado$.pipe(shareReplay(1));
  protected readonly modalTenentService = inject(ModalTenentService);

  toggleModal() {
    this.modalTenentService.toggleModal();
  }
}
